import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export const AtRiskCard = () => {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API}/delivery/at-risk`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        setData(res.data);
      } catch { /* card is best-effort */ }
    };
    load();
  }, []);

  if (!data) return null;
  const c = data.counts || {};
  const cell = (n, label, color, onClick, prefix) => (
    <button onClick={onClick} className="flex flex-col items-center px-3 py-2 rounded-lg bg-wt-bg border border-wt-border hover:border-wt-gold/50 transition-colors" data-testid={`atrisk-${prefix}-${label.replace(/\s/g, '-').toLowerCase()}`}>
      <span className={`text-xl font-bold ${n > 0 ? color : 'text-wt-text-muted'}`}>{n}</span>
      <span className="text-[11px] text-wt-text-muted whitespace-nowrap">{label}</span>
    </button>
  );
  const total = Object.values(c.production || {}).reduce((a, b) => a + b, 0) + Object.values(c.delivery || {}).reduce((a, b) => a + b, 0);

  return (
    <Card className="bg-wt-surface border-wt-border" data-testid="at-risk-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-wt-text-primary text-base flex items-center gap-2">
          <AlertTriangle className={`h-4 w-4 ${total > 0 ? 'text-amber-400' : 'text-wt-text-muted'}`} />
          Delivery Promises At Risk
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-wrap gap-4">
        <div>
          <p className="text-xs text-wt-text-muted mb-1">Production (expected ready)</p>
          <div className="flex gap-2">
            {cell(c.production?.overdue || 0, 'Overdue', 'text-red-400', () => navigate('/orders?tab=in_production'), 'production')}
            {cell(c.production?.today || 0, 'Due today', 'text-amber-400', () => navigate('/orders?tab=in_production'), 'production')}
            {cell(c.production?.tomorrow || 0, 'Due tomorrow', 'text-yellow-300', () => navigate('/orders?tab=in_production'), 'production')}
          </div>
        </div>
        <div>
          <p className="text-xs text-wt-text-muted mb-1">Delivery (customer estimate)</p>
          <div className="flex gap-2">
            {cell(c.delivery?.overdue || 0, 'Breached', 'text-red-400', () => navigate('/orders'), 'delivery')}
            {cell(c.delivery?.today || 0, 'Due today', 'text-amber-400', () => navigate('/orders'), 'delivery')}
            {cell(c.delivery?.tomorrow || 0, 'Due tomorrow', 'text-yellow-300', () => navigate('/orders'), 'delivery')}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AtRiskCard;
